export const ADMIN_INFO_KEY = 'dapscnect-admin';
export const ADMIN_TOKEN_KEY = 'dapscnect-admin-token';